<template>
<!-- icons-and-text -->
<div>
  <v-tabs
    v-if="show"
    class="taybull-tabs"
    v-model="active"
    :key="loadTime"
    :centered="chart.parameters.tabAlign.value == 'centered'"
    :right="chart.parameters.tabAlign.value == 'right'"
    :left="chart.parameters.tabAlign.value == 'left'"
    :color="chart.parameters.tabBgColor.value"
  >
    <v-tabs-slider :color="chart.parameters.sliderColor.value"></v-tabs-slider>
    <v-tab v-for="tab in chart.chartData.tabs" :key="tab.id" v-on:click="setTab(tab)">
      {{ tab.name }}
      <!-- <span :style="{color: chart.parameters.fontColor.value, 'text-transform': 'none'}">{{ tab.name }}</span> -->
      <!-- <v-icon>phone</v-icon> -->
    </v-tab>
    <v-tab-item v-for="tab in chart.chartData.tabs" :key="tab.id">
      <!-- <v-card flat>
        <v-card-text v-if="chart.tab && chart.tab.id == tab.id"> -->
          <TaybullLayout :mode="'view'" :chart="chart.tab" v-if="chart.tab && chart.tab.id == tab.id"  />
        <!-- </v-card-text>
      </v-card> -->
    </v-tab-item>
  </v-tabs>
</div>
</template>

<script>
import {
  createNamespacedHelpers
}
from 'vuex';
const chartNamespace = createNamespacedHelpers('charts');

const TaybullLayout = () => import('@/views/Layout.vue');

export default {
  props: ["chart"],
  data: function() {
    return {
      display: "tabs",
      active: null,
      tab: null,
      show: false,
    };
  },
  components: {
    TaybullLayout
  },
  methods: {
     ...chartNamespace.mapMutations(['mLoadChart']),
    ...chartNamespace.mapActions(["aLoadChart", "aLoadTab"]),
    setTab: function(tab) {
      // alert("Tabs");
      // this.tabs = this.chart.chartData.tabs.filter(tab=> )
      // console.log("setTab", tab.id + "===" + this.chart.id );
      // if(this.chart && this.chart.id === tab.id) {
      //   return;
      // }
      this.active = tab.id;
      
      // this.tab = tab;
      this.aLoadTab({chart: this.chart, tab: tab});
      // window.dispatchEvent(new Event('resize'));
      
      //this.aLoadChart(tab);
      // this.mLoadChart(tab);
      // console.log("this.active", this.active);
      // alert(tab.id);
    }
  },
  computed: {
    ...chartNamespace.mapState({
      loadTime: (state) => state.loadTime,
    }),
  },
  mounted: function() {
    // alert("Tabs");
    if(this.chart.chartData.tabs && this.chart.chartData.tabs.length) {
      this.setTab(this.chart.chartData.tabs[0]);
    }

    const that = this;
    setTimeout(() => {
      // alert('timeout');
      that.show = true;
      window.dispatchEvent(new Event('resize'));
    }, 10);
    
    
    this.chart.updateUI = function() {
      try {
       that.setTab(that.chart.chartData.tabs[0]);
      } catch(error) {
        // error
      }
      // alert("setTab");
    }
  },
  beforeDestroy() {}
};
</script>
